import React from 'react';

/**
 * Logomarca oficial — 100% code-based (SVG inline), sem dependência de arquivo.
 *
 * Conceito "Documento Certificado": um documento (folha com linhas de laudo)
 * carimbado por um selo de verificação verde — o mesmo motivo do Certificate Card.
 * Amarra a marca à promessa do produto: laudo registrado e verificável.
 *
 * Props:
 *  - showText: renderiza o wordmark ao lado da marca (default true)
 *  - dark: usar sobre fundo escuro (navy) — inverte as cores da folha e do texto
 *  - className: aplicado ao wrapper
 *  - markClassName: dimensiona só a marca (default h-9 w-9)
 */
const Logo = ({
  showText = true,
  dark = false,
  className = '',
  markClassName = 'h-9 w-9',
}) => {
  // Sobre fundo escuro, a folha vira clara e o texto branco.
  const sheet = dark ? '#FFFFFF' : '#101B3D';   // corpo do documento
  const sheetLine = dark ? '#101B3D' : '#FFFFFF'; // linhas dentro do documento
  const selo = '#0F7A5C';                          // selo de verificação (constante)

  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <svg
        viewBox="0 0 40 40"
        className={markClassName}
        role="img"
        aria-label="Laudando Online"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Documento (folha com canto dobrado) */}
        <path
          d="M9 4.5h13.2L31 13v18.5a4 4 0 0 1-4 4H13a4 4 0 0 1-4-4v-23a4 4 0 0 1 4-4Z"
          fill={sheet}
        />
        {/* Canto dobrado */}
        <path d="M22 4.6V11a2 2 0 0 0 2 2h6.4L22 4.6Z" fill={sheet} opacity="0.55" />
        {/* Linhas de conteúdo do laudo */}
        <rect x="13.5" y="16.5" width="12" height="2" rx="1" fill={sheetLine} />
        <rect x="13.5" y="21" width="12" height="2" rx="1" fill={sheetLine} />
        <rect x="13.5" y="25.5" width="7.5" height="2" rx="1" fill={sheetLine} />
        {/* Selo de verificação (escudo com check) sobreposto no canto inferior direito */}
        <circle cx="29" cy="29" r="8" fill={dark ? '#101B3D' : '#FFFFFF'} />
        <circle cx="29" cy="29" r="6.4" fill={selo} />
        <path
          d="m26.1 29.1 1.9 1.9 3.9-4"
          stroke="#FFFFFF"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>

      {showText && (
        <span className="leading-none">
          <span
            className="font-display font-bold tracking-tight text-[1.15rem]"
            style={{ color: dark ? '#FFFFFF' : '#101B3D' }}
          >
            Laudando
          </span>
          <span
            className="font-sans font-semibold text-[1.15rem] ml-1"
            style={{ color: dark ? 'rgba(255,255,255,0.6)' : '#5B6472' }}
          >
            Online
          </span>
        </span>
      )}
    </span>
  );
};

export default Logo;
